var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportingNewReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "reporting_new_entry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.62,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "reporting_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 300,
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.32,244.55H357.05V159.37a56.19,56.19,0,0,0-56-56h0a56.19,56.19,0,0,0-56,56v85.18H164.83a56.19,56.19,0,0,0-56,56h0a56.19,56.19,0,0,0,56,56H245v85.27a56.2,56.2,0,0,0,56,56h0a56.2,56.2,0,0,0,56-56V356.6h90.27a56.19,56.19,0,0,0,56-56h0A56.19,56.19,0,0,0,447.32,244.55Z",
    fill: "#eaeaea"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingNewReport);
export default __webpack_public_path__ + "static/media/reporting_new_report.cb17edee8912be70f479df563f9a4634.svg";
export { ForwardRef as ReactComponent };